import { isObject, isArray, has } from 'lodash'
import { ENCRYPTED_KEY } from '../Constants/dato'
import { decrypt } from '../utilities/cryptoUtils'

/**
 * Decrypts the encrypted portion of a datoObject and merges it with the rest of the object's properties.
 *
 * @param {Object} datoObject - The object containing an encrypted key and other properties.
 * @returns {Object} A new object with the decrypted properties merged with the original properties, excluding the encrypted key.
 */
export const decryptDatoObject = (datoObject) => {
  let decryptedObject
  try {
    decryptedObject = decrypt(datoObject[ENCRYPTED_KEY])
  } catch (e) {
    decryptedObject = {}
  }

  const rest = { ...datoObject }

  delete rest[ENCRYPTED_KEY]

  return {
    ...rest,
    ...decryptedObject
  }
}

/**
 * Recursively decrypts answers in a Dato content object or array.
 * If the content contains an encrypted key, it will be decrypted using `decryptDatoObject`.
 * Handles nested arrays and objects, ensuring all encrypted answers are decrypted.
 *
 * @param {Object|Array} content - The Dato content to decrypt, can be an object or array.
 * @returns {Object|Array} - The decrypted content, with all encrypted answers decrypted.
 */
export const decryptAnswersInDatoContent = (content) => {
  if (!isObject(content)) {
    return content
  }

  if (isArray(content)) {
    return content.map(item => decryptAnswersInDatoContent(item))
  }

  if (has(content, ENCRYPTED_KEY)) {
    return decryptDatoObject(content)
  }

  const result = { ...content }

  Object.keys(result).forEach(key => {
    if (isArray(result[key]) || isObject(result[key])) {
      result[key] = decryptAnswersInDatoContent(result[key])
    }
  })

  return result
}
